import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import UserAnalytic from './UserAnalytic';
import { FaArrowLeftLong } from 'react-icons/fa6'

const UserAnalyticReport = () => {
    const location = useLocation();
    const {userUUID } = location.state;
    const navigate = useNavigate();

    return (
        <>
            <div className='bg-grey-main'>
                <div className='p-2'>
                    <button className='backbtn cursor-pointer ps-2 mt-2' title="Back" onClick={() => navigate(-1)}> <FaArrowLeftLong /> Back </button>
                </div>
                <div className="row px-2" >
                    <UserAnalytic type="analyticReportUser" userUUID={userUUID} />
                </div>
            </div>

        </>
    )
}

export default UserAnalyticReport
